import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { first } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  @ViewChild('photoGallery', { static: true }) photoGallery!: ElementRef;
  @ViewChild('videoGallery', { static: true }) videoGallery!: ElementRef;

  @ViewChild('targetSection1') targetSection1: ElementRef;
  @ViewChild('targetSection2') targetSection2: ElementRef;
  @ViewChild('targetSection3') targetSection3: ElementRef;
  @ViewChild('targetSection4') targetSection4: ElementRef;
  @ViewChild('targetSection5') targetSection5: ElementRef;

  selectedLang: any;
  bannerScrollerImages: any = [];

  images = [
    // {
    //   previewImageSrc: '../../../assets/home/h-img3.png',
    // },
    {
      previewImageSrc: '../../../assets/home/images/Cotton Crop with Drip Irrigation System.jpg',
      description: 'Cotton Crop with Drip Irrigation System'
    },
    {
      previewImageSrc: '../../../assets/home/images/Wheat with mini sprinklers in Budak, Hisar, 08.03.24.JPG',
      description: 'Wheat with mini sprinklers in Budak, Hisar, 08.03.24'
    },
    {
      previewImageSrc: '../../../assets/home/images/Chickpea roots with nitrogen fixing nodules (RHS) with drip and flooded (LHS), Budak, Hisar, 08.03.24.JPG',
      description: 'Chickpea roots with nitrogen fixing nodules (RHS) with drip and flooded (LHS), Budak, Hisar, 08.03.24'
    },
    {
      previewImageSrc: '../../../assets/home/images/Citrus intercropped with drip irrigated mustard, Arya Nagar, Hisar, 18.01.2024.JPG',
      description: 'Citrus intercropped with drip irrigated mustard, Arya Nagar, Hisar, 18.01.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Drip irrigated wheat after cotton harvest in Mangali Suratiya, Hisar, 12.1.24.JPG',
      description: 'Drip irrigated wheat after cotton harvest in Mangali Suratiya, Hisar, 12.1.24'
    },
    {
      previewImageSrc: '../../../assets/home/images/Drip irrigated wheat in 8 acre in Mangali Suratiya, Hisar, 12.1.2024.JPG',
      description: 'Drip irrigated wheat in 8 acre in Mangali Suratiya, Hisar, 12.1.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Harvesting Paired row drip irrigated mustard after cotton in Budak village, Hisar, 20.03.24.JPG',
      description: 'Harvesting Paired row drip irrigated mustard after cotton in Budak village, Hisar, 20.03.24'
    },
    {
      previewImageSrc: '../../../assets/home/images/Less root rot in drip irrigated over flood irrigated mustard, Aryanagar, Hisar, 26.02.2024.JPG',
      description: 'Less root rot in drip irrigated over flood irrigated mustard, Aryanagar, Hisar, 26.02.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Mustard after cotton with paired row sowing (120 cm driplies) in Budak, Hisar, 08.03.2024.JPG',
      description: 'Mustard after cotton with paired row sowing (120 cm driplies) in Budak, Hisar, 08.03.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Tomato with drip and poly mulch in the field of Dr. Harish Gupta, Balsamand, Hisar, 8.3.2024.jpg',
      description: 'Tomato with drip and poly mulch in the field of Dr. Harish Gupta, Balsamand, Hisar, 8.3.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Chickpea after cotton using 120 cm driplines with paired row sowing, Budak, Hisar, 08.03.2024.jpg',
      description: 'Chickpea after cotton using 120 cm driplines with paired row sowing, Budak, Hisar, 08.03.2024'
    },
    {
      previewImageSrc: '../../../assets/home/images/Paired row drip irrigated mustard after cotton harvest towards maturity in Budak village, Hisar, 20.03.24.JPG',
      description: 'Paired row drip irrigated mustard after cotton harvest towards maturity in Budak village, Hisar, 20.03.24'
    },
    {
      previewImageSrc: '../../../assets/home/images/Mini sprinkler irrigated wheat field, Khairampur, Hisar, 07.03.24.JPG',
      description: 'Mini sprinkler irrigated wheat field, Khairampur, Hisar, 07.03.24'
    },
  ];

  videos = [
    // {
    //   url: '../../../assets/home/videos/Vertical Drainage Success Story - Jhajjar.mp4',
    //   description: 'Vertical Drainage Success Story - Jhajjar'
    // },
    // {
    //   url: '../../../assets/home/videos/DHOLI MINOR.mp4',
    //   description: 'DHOLI MINOR'
    // },
    {
      url: 'https://www.youtube.com/embed/aFG9zsm-Rxw',
      description: 'District Karnal MI SCHEME'
    },
    {
      url: 'https://www.youtube.com/embed/i6Pc5StsWtA',
      description: 'Drip irrigated wheat in the field of Devi Lal Godara, Mangali Suratiya, Hisar, 12.01.24'
    },
    {
      url: 'https://www.youtube.com/embed/LmA9pXU0uYs',
      description: 'Everything you need to know about MICADA- A complete overview'
    },
    {
      url: 'https://www.youtube.com/embed/p5XYu5QQdzY',
      description: 'Jhajjar Video 2024-12-03 at 4.57.45 PM'
    },
    {
      url: 'https://www.youtube.com/embed/Yb5Elz7dGrE',
      description: 'Maximizing Sugarcane Yield- The powe of Micro Irrigation in fields'
    },
    {
      url: 'https://www.youtube.com/embed/BK6nxhGbhTU',
      description: 'MI Infrastructure at RD 11000-L Deewana Disty'
    },
    {
      url: 'https://www.youtube.com/embed/TBLfB4l6qnE',
      description: 'RD- 14365L BHANDOR DISTY'
    },
    {
      url: 'https://www.youtube.com/embed/smoUp-KHCYA',
      description: 'Rinku Kumar from Yamunanagar- Real results with MI'
    },
    {
      url: 'https://www.youtube.com/embed/aFG9zsm-Rxw',
      description: 'District Karnal MI SCHEME'
    },
    {
      url: 'https://www.youtube.com/embed/rXdKXflfc-o',
      description: 'Micro Irrigation Project at outlet 25220/L Sandhola Minor, Teh Pehowa, Distt Kurukshetra, Haryana.'
    },
    // {
    //   url: '../../../assets/home/videos/MI at 81000-R Sudkan Disty Kaithal.mp4',
    //   description: 'MI at 81000-R Sudkan Disty Kaithal'
    // },
  ]

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  leaders: any;
  displayImages: boolean = false;
  activeIndex: any;

  private photoScrollInterval: any;
  private videoScrollInterval: any;

  menuLoginItems: any[] = [];

  selectedImageFilter: any;
  selectedVideoFilter: any;
  galleryFilterList: any = [];

  items: MenuItem[] | undefined;

  constructor(
    private translateService: TranslateService,
    public authService: AuthenticationService,
    public router: Router,
    private translate: TranslateService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit() {
    this.getInitialTokenNew();
    this.loadMenuItems();
    this.loadLeadersName();
    this.loadBannerImages();

    // this.menuLoginItems = [
    //   {
    //     label: 'Apply for Overflow-Pond Water Based Application',
    //     command: () => window.open('/phone-login', '_blank')
    //   },
    //   {
    //     label: 'Apply for Canal Water Based Application',
    //     command: () => window.open('/phone-login', '_blank')
    //   },
    //   {
    //     label: 'Apply for Tube-well Water Based Application',
    //     command: () => window.open('/phone-login', '_blank')
    //   }
    // ];


    this.loadFilterVal();
    if (localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang.code)
    }

    if (window.sessionStorage.getItem('autoLoggedOut') && window.sessionStorage.getItem('autoLoggedOut') == '1') {
      this.getInitialToken();
    }

    this.startAutoScroll('photo');
    this.startAutoScroll('video');

    this.translate.onLangChange.subscribe(() => {
      this.loadMenuItems();
      this.loadLeadersName();
      this.loadBannerImages();
    });
  }

  getInitialTokenNew(){
    this.authService
      .getInitialToken()
      .pipe(first())
      .subscribe({
        next: (response) => {
          if (response){
            sessionStorage.setItem("token", response.data)
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: `Next level user not found. ${err}`,
          // });
        },
      });
  }

  loadMenuItems() {
    this.items = [
      {
        label: this.translate.instant('HOME'),
        icon: 'pi pi-home',
        command: () => this.onClickHeader('home')
      },
      {
        label: this.translate.instant('ABOUT_US'),
        // icon: 'pi pi-star',
        items: [
          {
            label: this.translate.instant('ABOUT_US'),
            icon: 'pi pi-star',
            command: () => this.onClickHeader('aboutUs')
          },
          {
            label: this.translate.instant('SUCCESS_STORIES'),
            icon: 'pi pi-slack',
            command: () => this.router.navigate(['/success-stories'])
          },
        ]
      },
      {
        label: this.translate.instant('CADMIS'),
        icon: 'pi pi-external-link',
        command: () => window.open('https://wms.micada.haryana.gov.in/', '_blank')
      },
      {
        label: this.translate.instant('RTI'),
        icon: 'pi pi-star',
        command: () => this.onClickHeader('rti')
      },
      // {
      //   label: this.translate.instant('PROGRESS_CHART'),
      //   icon: 'pi pi-star',
      //   command: () => this.onClickHeader('progressChart')
      // },
      {
        label: this.translate.instant('ORGANISATION'),
        icon: 'pi pi-sparkles',
        items: [
          {
            label: this.translate.instant('HEAD_OFF_EXECUTIVES'),
            icon: 'pi pi-th-large',
            command: () => this.onClickHeader('headOffExecutives')
          },
          {
            label: this.translate.instant('FIELD_EXECUTIVES'),
            icon: 'pi pi-slack',
            command: () => this.onClickHeader('fieldExecutives')
          },
          {
            label: this.translate.instant('OFFICE_ORDERS'),
            icon: 'pi pi-file',
            command: () => this.onClickHeader('officeOrders')
          },
        ]
      },
      {
        label: this.translate.instant('MI_SCHEME'),
        icon: 'pi pi-star',
        command: () => this.onClickHeader('newTarget')
      },
      {
        label: this.translate.instant('PHOTO_VIDEO_GALLERY'),
        icon: 'pi pi-server',
        items: [
          {
            label: this.translate.instant('PHOTO_GALLERY'),
            icon: 'pi pi-images',
            // command: () => this.onClickHeader('imageVideoGal')
            command: () => this.router.navigate(['/photo-gallery'])
          },
          {
            label: this.translate.instant('VIDEO_GALLERY'),
            icon: 'pi pi-video',
            command: () => this.router.navigate(['/video-gallery'])
          }
        ]
      },
      {
        label: this.translate.instant('FAQs'),
        icon: 'pi pi-question-circle',
        items: [
          {
            label: this.translate.instant('FAQ_L1'),
            icon: 'pi pi-link',
            command: () => window.open('https://micadaharyana.nic.in/FAQ1.pdf', '_blank')
          },
          {
            label: this.translate.instant('FAQ_L2'),
            icon: 'pi pi-link',
            command: () => window.open('https://micadaharyana.nic.in/FAQ2.pdf', '_blank')
          },
          {
            label: this.translate.instant('FAQ_L3'),
            icon: 'pi pi-link',
            command: () => window.open('https://micadaharyana.nic.in/FAQ3.pdf', '_blank')
          }
        ]
      },
      {
        label: this.translate.instant('LOGIN'),
        icon: 'pi pi-sign-in',
        items: [
          {
            label: this.translate.instant('OFFICER_LOGIN'),
            icon: 'pi pi-users',
            command: () => this.onClickLogin('login')
          },
          {
            label: this.translate.instant('VENDOR_LOGIN'),
            icon: 'pi pi-users',
            command: () => this.onClickLogin('login')
          },
          {
            label: this.translate.instant('NEW_REGISTRATION'),
            icon: 'pi pi-users',
            command: () => this.onClickLogin('vendor-registration')
          }
        ]
      },
      {
        label: this.translate.instant('CONTACT_US'),
        icon: 'pi pi-envelope',
        command: () => this.onClickHeader('contactUs')
      },
    ];
  }

  loadBannerImages() {
    this.bannerScrollerImages = [
      {
        previewImageSrc: '../../../assets/home/resize/Drip irrigated wheat in 8 acre in Mangali Suratiya, Hisar, 12.1.2024.jpg',
        description: this.translate.instant('DRIP_IRR_WHEAT_IN_8ACR'),
      },
      {
        previewImageSrc: '../../../assets/home/resize/Wheat with mini sprinklers in Budak, Hisar, 08.03.24.jpg',
        description: this.translate.instant('WHEAT_WITH_MIN_SPRINKLERS'),
      },
      {
        previewImageSrc: '../../../assets/home/resize/Tomato with drip and poly mulch in the field of Dr. Harish Gupta, Balsamand, Hisar, 8.3.2024.jpg',
        description: this.translate.instant('TOMATO_WITH_DRIP&POLY_MULCH'),
      },
      {
        previewImageSrc: '../../../assets/home/resize/Harvesting Paired row drip irrigated mustard after cotton in Budak village, Hisar, 20.03.24.jpg',
        description: this.translate.instant('HARVERSTING_PAIRED_ROW_DRIP'),
      },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Chickpea roots with nitrogen fixing nodules (RHS) with drip and flooded (LHS), Budak, Hisar, 08.03.24.jpg',
      //   description: this.translate.instant('CHICKPEA_ROOTS_WITH_NITROGEN'),
      // },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Drip irrigated wheat after cotton harvest in Mangali Suratiya, Hisar, 12.1.24.jpg',
      //   description: this.translate.instant('DRIP_IRR_WHEAR_AFTER_COTTON'),
      // },
      {
        previewImageSrc: '../../../assets/home/resize/Citrus intercropped with drip irrigated mustard, Arya Nagar, Hisar, 18.01.2024.jpg',
        description: this.translate.instant('CITRUS_INTERCROPPED_WITH_DRIP_IRR'),
      },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Less root rot in drip irrigated over flood irrigated mustard, Aryanagar, Hisar, 26.02.2024.jpg',
      //   description: this.translate.instant('LESS_ROOT_IN_DRIP_IRR'),
      // },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Mustard after cotton with paired row sowing (120 cm driplies) in Budak, Hisar, 08.03.2024.jpg',
      //   description: this.translate.instant('MUSTARD_AFTER_COTTON_WITH_PAIRED'),
      // },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Paired row drip irrigated mustard after cotton harvest towards maturity in Budak village, Hisar, 20.03.24.jpg',
      //   description: this.translate.instant('PAIRED_ROW_DRIP_IRR_MUSTARD'),
      // },
      {
        previewImageSrc: '../../../assets/home/resize/Mini sprinkler irrigated wheat field, Khairampur, Hisar, 07.03.24.jpg',
        description: this.translate.instant('MINI_SPRINKLER_IRR_WHEAT_FIELD'),
      },
      // {
      //   previewImageSrc: '../../../assets/home/resize/Cotton Crop with Drip Irrigation System.jpg',
      //   description: this.translate.instant('COTTON_CROP_WITH_DRIP_IRR'),
      // },
    ]
  }

  loadLeadersName() {
    this.leaders = [
      {
        name: this.translate.instant('IRRIGATION_MIN_NAME'),
        title: this.translate.instant('IRRIGATION_MIN'),
        location: this.translate.instant('HARYANA'),
        image: '../../../assets/activitiesImages/ir_min.jpeg',
      },
      {
        name: this.translate.instant('ADD_CHIEF_SEC_NAME'),
        title: this.translate.instant('ADD_CHIEF_SEC'),
        location: this.translate.instant('I&WRD_HARYANA'),
        image: '../../../assets/activitiesImages/chief_sec.jpg',
      },
      {
        name: this.translate.instant('ADMINISTRATOR_NAME'),
        title: this.translate.instant('ADMINISTRATOR'),
        location: this.translate.instant('MICADA_HARYANA'),
        image: 'assets/activitiesImages/admin.jpeg',
      },
    ];
  }

  onClickLogin(val) {
    if (val == 'noc') {

      if (environment.staging) {
        this.router.navigate(['/tubewell-connection-login']);
      } else if (environment.production) {
        window.open('/tubewell-connection-login', '_blank')
      }
    } else if (val == 'farmer-stp') {
      sessionStorage.setItem('loginWS', 'STP');

      if (environment.staging) {
        this.router.navigate(['/phone-login']);
      } else if (environment.production) {
        window.open('/phone-login', '_blank')
      }
    } else if (val == 'farmer-overflow-pond' || val == 'farmer-canal' || val == 'farmer-tubewell') {

      if (environment.staging) {
        this.router.navigate(['/phone-login']);
      } else if (environment.production) {
        window.open('/phone-login', '_blank')
      }
    } else if (val == 'vendor-registration') {
      this.router.navigate(['/vendor-registration-login']);
    } else {
      if (environment.staging) {
        this.router.navigate(['/login']);
      } else if (environment.production) {
        window.open('/login', '_blank')
      }
    }
  }

  loadFilterVal() {
    setTimeout(() => {
      this.galleryFilterList = [
        {
          label: 'Canal Based MI Pilot Projects',
          value: ''
        },
        {
          label: 'Canal Based Community MI Projects',
          value: ''
        },
        {
          label: 'Canal Based OFPs MI Projects',
          value: ''
        },
        {
          label: 'Canal Based OFPs MI Projects',
          value: ''
        },
        {
          label: 'Rice Crop with MI',
          value: ''
        },
        {
          label: 'Potato Crop with MI',
          value: ''
        },
        {
          label: 'Sugarcane with MI',
          value: ''
        },
      ];
    })
  }

  languageChange(event) {
    localStorage.setItem('lang', JSON.stringify(event.value))
    this.translateService.use(event.value.code);
  }

  onChildValueChanged(value) {
    // this.translate.onLangChange.subscribe(() => {
    //   this.loadMenuItems();
    //   this.loadLeadersName();
    // });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayImages = true;
  }

  getInitialToken() {
    this.authService.getInitialToken().subscribe((response: any) => {
      if (response) {
        sessionStorage.setItem("token", response.data)
        window.sessionStorage.setItem('autoLoggedOut', '0');
      }
    });
  }

  startAutoScroll(type: 'photo' | 'video') {
    const gallery = type === 'photo' ? this.photoGallery.nativeElement : this.videoGallery.nativeElement;
    const scrollSpeed = 1.5; // Adjust for smoothness

    const scrollFn = () => {
      if (gallery.scrollTop + gallery.offsetHeight >= gallery.scrollHeight) {
        gallery.scrollTop = 0; // Reset to the top
      } else {
        gallery.scrollTop += scrollSpeed; // Increment scroll
      }
    };

    if (type === 'photo') {
      this.photoScrollInterval = setInterval(scrollFn, 50);
    } else {
      this.videoScrollInterval = setInterval(scrollFn, 50);
    }
  }

  pauseScroll(type: 'photo' | 'video') {
    if (type === 'photo') {
      clearInterval(this.photoScrollInterval);
    } else {
      clearInterval(this.videoScrollInterval);
    }
  }

  resumeScroll(type: 'photo' | 'video') {
    this.startAutoScroll(type);
  }

  ngOnDestroy() {
    clearInterval(this.photoScrollInterval);
    clearInterval(this.videoScrollInterval);
  }

  public showHome: boolean = true;
  public showActivities: boolean = false;
  public showOfficeOrders: boolean = false;
  public showStatistics: boolean = false;
  public showRti: boolean = false;
  public showNewInitiatives: boolean = false;
  public showOrgSetup: boolean = false;
  public showBenDetails: boolean = false;
  public showAchievements: boolean = false;
  public showMicroIrrigation: boolean = false;
  public showAnnualPlan: boolean = false;
  public showEvaluationStudy: boolean = false;
  public showNewTarget: boolean = false;
  public showProject: boolean = false;
  public showFieldExecutives: boolean = false;
  public showHeadOffExecutives: boolean = false;

  onClickHeader(val) {
    if (val == 'home' || val == 'aboutUs' || val == 'contactUs' || val == 'imageVideoGal') {
      this.showHome = true;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection(val);
    } else if (val == 'activities') {
      this.showHome = false;
      this.showActivities = true;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'officeOrders') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = true;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'statistics') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = true;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'rti') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = true;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'newInitiatives') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = true;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'orgSetup') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = true;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'beneDetails') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = true;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'achievements') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = true;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'microIrrigation') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = true;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'annualPlan') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = true;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'evaluationStudy') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = true;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'newTarget') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = true;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'project') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = true;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    } else if (val == 'fieldExecutives') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = true;
      this.showHeadOffExecutives = false;
      this.callTargetSection('2');
    }else if (val == 'headOffExecutives') {
      this.showHome = false;
      this.showActivities = false;
      this.showOfficeOrders = false;
      this.showStatistics = false;
      this.showRti = false;
      this.showNewInitiatives = false;
      this.showOrgSetup = false;
      this.showBenDetails = false;
      this.showAchievements = false;
      this.showMicroIrrigation = false;
      this.showAnnualPlan = false;
      this.showEvaluationStudy = false;
      this.showNewTarget = false;
      this.showProject = false;
      this.showFieldExecutives = false;
      this.showHeadOffExecutives = true;
      this.callTargetSection('2');
    }
  }

  callTargetSection(val) {
    if (val == 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else if (val == 'aboutUs') {
      window.scrollTo({
        top: 600,
        behavior: 'smooth'
      });
    } else if (val == 'imageVideoGal') {
      window.scrollTo({
        top: 850,
        behavior: 'smooth'
      });
    } else if (val == 'contactUs') {
      // window.scrollTo({
      //   top: 2000,
      //   behavior: 'smooth'
      // });
      setTimeout(() => this.targetSection5.nativeElement.scrollIntoView({
        block: "start",
        behavior: "smooth"
      }), 400)
    } else {
      // setTimeout( () => this.targetSection2.nativeElement.scrollIntoView({
      //   block: "end",
      //   behavior: "smooth"
      // }), 400)
      window.scrollTo({
        top: 600,
        behavior: 'smooth'
      });
    }
  }

  onSelectFilter() {
  }

  onPhotoGalleryClick() {
    this.router.navigate(['/photo-gallery']);
  }

  onVideosClick() {
    this.router.navigate(['/video-gallery']);
  }
}
